import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./event.css";

export default function AddEvent() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [form,    setForm]    = useState({ title: "", date: "", description: "" });
  const [file,    setFile]    = useState(null);
  const [saving,  setSaving]  = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.date) return alert("Title and Date are required");
    try {
      setSaving(true);
      const fd = new FormData();
      fd.append("title",       form.title);
      fd.append("date",        form.date);
      fd.append("description", form.description);
      if (file) fd.append("file", file);
      await API.post("/school-admin/events/add/", fd, {
        headers: { "X-SCHOOL-ID": school.school.id, "Content-Type": "multipart/form-data" },
      });
      navigate("/school-admin/events");
    } catch (err) { console.error(err); alert("Failed to create event"); }
    finally { setSaving(false); }
  };

  return (
    <div className="ev-page">

      {/* ══ HERO ══ */}
      <div className="ev-hero">
        <div className="ev-hero-left">
          <div className="ev-hero-icon">🎉</div>
          <div>
            <h2 className="ev-hero-title">Add Event</h2>
            <p className="ev-hero-sub">Create a new school event for students</p>
          </div>
        </div>
        <div className="ev-hero-right">
          <button className="ev-btn-back" onClick={() => navigate("/school-admin/events")}>
            ← Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="ev-form-card">
          <p className="ev-form-section-title">Event Details</p>

          {/* Title + Date */}
          <div className="ev-grid-2">
            <div className="ev-field">
              <label>Event Title *</label>
              <input
                required
                placeholder="e.g. Annual Sports Day"
                value={form.title}
                onChange={e => set("title", e.target.value)}
              />
            </div>
            <div className="ev-field">
              <label>Event Date *</label>
              <input
                type="date" required
                value={form.date}
                onChange={e => set("date", e.target.value)}
              />
            </div>
          </div>

          {/* Description */}
          <div className="ev-field" style={{ marginBottom: "24px" }}>
            <label>Description</label>
            <textarea
              placeholder="Short details about the event…"
              value={form.description}
              onChange={e => set("description", e.target.value)}
            />
          </div>

          {/* File upload */}
          <div
            className="ev-file-zone"
            onClick={() => document.getElementById("ev-file-input").click()}
          >
            <div className="ev-file-zone-label">📎 Attachment (PNG / JPG / PDF)</div>
            <div className="ev-file-zone-hint">Click to browse — optional</div>
            {file && <div className="ev-file-name">{file.name}</div>}
            <input
              id="ev-file-input"
              type="file"
              accept=".png,.jpg,.jpeg,.pdf"
              hidden
              onChange={e => setFile(e.target.files[0] || null)}
            />
          </div>

          <button type="submit" className="ev-btn-submit" disabled={saving}>
            {saving
              ? <><div className="ev-spinner"></div> Saving…</>
              : "✓ Save Event"
            }
          </button>
        </div>
      </form>

    </div>
  );
}
